import {useEffect, useState} from "react";
import {getOrDefault, groupBy} from "../../../utils/collection-util";
import _ from "lodash"
import {ContactType} from "../../profile/domain/contact-type";
import {ContactChangeStatus} from "../index";


const initialData = Object.keys(ContactType)
    .reduce((res, key) => ({...res, [key]: []}), {});
export const useContactsUpdater = (contacts) => {
    const [data, setData] = useState(initialData)
    const [oldData, setOldData] = useState(null)
    const [isChanged, setChanged] = useState(false)

    useEffect(() => {
        if (contacts == null) return

        const copied_contacts = _.cloneDeep(contacts)
            .map((contact) => ({
                id: contact.id,
                serviceType: contact.serviceType,
                title: contact.title,
                content: contact.content,
                status: ContactChangeStatus.NONE
            }))

        const groupedContacts = groupBy(copied_contacts, (contact) => contact.serviceType)

        const data = Object.keys(ContactType)
            .reduce((res, key) => (
                {...res, [key]: getOrDefault(groupedContacts, key, [])}), {})

        setData(data)
        setOldData(_.cloneDeep(data))
    }, [contacts])

    useEffect(() => {
        if (oldData == null) {
            return
        }

        const checkChanged = JSON.stringify(oldData) !== JSON.stringify(data)

        setChanged(checkChanged)
    }, [data])

    const checkChangeStatus = (serviceType, newContact) => {
        const oldContact = oldData[serviceType].find((v) => getOrDefault(newContact, "id", null) === v.id)

        // 이전엔 없지만 지금 있을때 추가
        if (oldContact === undefined && newContact !== null) {
            return ContactChangeStatus.ADD
        }

        // 이전에 있었고 지금도 있으면 수정
        if (oldContact !== undefined && newContact !== null) {
            if (oldContact.title === newContact.title &&
                oldContact.content === newContact.content) {
                return ContactChangeStatus.NONE
            } else {
                return ContactChangeStatus.UPDATE
            }
        }

        throw Error('IllegalArgumentException')
    }

    const updater = {
        add(serviceType, title, content) {
            const newValues = {...data}
            const newContact = {
                id: null,
                serviceType: serviceType,
                title: title,
                content: content,
                status: ContactChangeStatus.ADD
            };
            newValues[serviceType].push(newContact)

            setData(newValues)
        },
        remove(serviceType, index) {
            const newValues = {...data}
            const newContact = newValues[serviceType][index]

            if (newContact.status === ContactChangeStatus.ADD) {
                newValues[serviceType].splice(index, 1)
            } else {
                newContact.status = ContactChangeStatus.DELETE
            }

            setData(newValues)
        },
        updateTitle(serviceType, index, title) {
            const newValues = {...data}
            const contact = newValues[serviceType][index];
            contact.title = title
            contact.status = checkChangeStatus(serviceType, contact);

            setData(newValues)
        },
        updateContent(serviceType, index, content) {
            const newValues = {...data}
            const contact = newValues[serviceType][index];
            contact.content = content
            contact.status = checkChangeStatus(serviceType, contact);

            setData(newValues)
        },
        getContacts(serviceType = null, includeDeletedContacts = false) {
            const contacts = serviceType == null
                ? Object.values(data).flat()
                : data[serviceType]

            return includeDeletedContacts
                ? contacts
                : contacts.filter((contact) => contact.status !== ContactChangeStatus.DELETE)
        },
        isContactsNotEmpty(serviceType) {
            return data[serviceType]
                .filter((contact) => contact.status !== ContactChangeStatus.DELETE)
                .length > 0
        },
        undoChanges(serviceType) {
            const newValues = {...data}
            newValues[serviceType] = oldData[serviceType];
            setData(newValues)
        }
    }

    return [updater, isChanged]
}